import { current } from "@reduxjs/toolkit";

export const getAssetTarget = (state, action, assetId) => {
  let currentAssetId = assetId;
  if (!currentAssetId) {
    currentAssetId = action.meta.arg?.assetId;
  }
  const stateData = current(state.application);
  const isMainAsset = stateData.asset._id === currentAssetId;
  return isMainAsset
    ? state.application.asset
    : state.application.additionalAssets.find(
        (el) => el?._id === currentAssetId
      );
};

export const handleAssetLoaderState = (state, action, { loaderKey }) => {
  const typeParts = action.type.split("/");
  const status = typeParts[typeParts.length - 1];

  switch (status) {
    case "pending":
      state[loaderKey] = {
        assetId: action.meta.arg?.assetId,
        isLoading: true,
      };
      break;

    case "rejected":
      state[loaderKey] = {
        assetId: "",
        isLoading: false,
      };
      break;

    case "fulfilled":
      state[loaderKey] = {
        assetId: "",
        isLoading: false,
      };
      break;

    default:
      break;
  }
  return;
};
